// @flow

import { connect } from 'react-redux';
import matchUpSelectionsSelector from '../../selectors/matchUpSelectionsSelector';
import matchUpsSelector from '../../selectors/matchUpsSelector';
import * as challengeActions from '../../actions/challengeActions';
import RapidFireTeamSelectionBase from './RapidFireTeamSelectionBase';

function mapStateToProps(state) {
  return {
    hasLightBackground: !state.settings.darkMode,
    showHeader: false,
    startTime: state.challenge.startTime,
    statusLabel: state.challenge.statusLabel,
    statusId: state.challenge.statusId,
    matchUps: matchUpsSelector(state),
    myEntrySelections: matchUpSelectionsSelector(state),
    entryId: state.entry.myEntry.id,
    sportId: state.challenge.sportId,
    competitionId: state.challenge.competitionId
  };
}

const actions = {
  stopPoll: challengeActions.stopPollingChallenge,
  startPoll: challengeActions.pollChallenge
};

export default connect(mapStateToProps, actions)(RapidFireTeamSelectionBase);
